import React from 'react'
import PropTypes from 'prop-types'
import { MemoryRouter } from 'react-router-dom'
import { MemoryRouterProvider } from './memory-router-context'

export default function ZionMemoryRouter({ linksAsButtons = true, ...props }) {
  return (
    // The linksAsButtons={false} should only be used in tests where you set up a MemoryRouter just for your test.
    <MemoryRouterProvider linksAsButtons={linksAsButtons}>
      <MemoryRouter {...props} />
    </MemoryRouterProvider>
  )
}

ZionMemoryRouter.propTypes = {
  /** Should only be set to false in tests where you set up a MemoryRouter for your test and you're expecting anchor tags. */
  linksAsButtons: PropTypes.bool,
}
